<template>
  <div style="height: 100px;text-align: center;" :style="{
      '--radio-button-color': $store.getters.getRadioButtonColor,
      '--star-svg-height': `${starHeight}px`
      }">
    <ul class="rating-card__list">
      <li class="rating-card__list__item" v-bind:class="{'-select': model.crowded}"
          v-for="(model, index) in question.answers"
          v-on:click="selectStar(model, index)" v-bind:key="index">
        <label>
          <svg xmlns="http://www.w3.org/2000/svg" v-bind:class="{'bounce': model.bounced}" class="star-ico"
               x="0px" y="0px"
               viewBox="0 0 576 512" style="enable-background:new 0 0 576 512;" xml:space="preserve">
             <path d="M309.5,85.8c-13.9,20.9-55.7,83.6-55.7,83.6l0,0C205,120.7,142.3,99.8,79.5,134.6S-25,267,16.8,329.7 C86.5,448.2,205,531.8,344.3,462.1c90.6-41.8,153.3-139.4,209.1-223C651,85.8,407.1-74.4,309.5,85.8"/>
          </svg>
          <div style="font-weight:200">{{ model.title }}&nbsp;&nbsp;</div>
        </label>
      </li>
    </ul>


    <label v-for="model in question.answers" v-bind:key="model.uid">
      <input style="display:none;" type="radio"
             v-bind:id="'star'+ model.uid"
             v-on:click="setRadio(model.uid)"
             :value="model.uid"
             :name="question.uid"
             :checked="model.selected"
      />
    </label>

    <transition name="fade">
      <comment v-show="showComment" :placeholder="commentPlaceholder" :name="commentName"></comment>
    </transition>
    <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
  </div>
</template>

<script>
import Vue from 'vue';
import Comment from './Comment';
import Star from 'vue-rate-it/glyphs/star';


export default {
  name: 'heart',
  props: ['question'],
  data() {
    return {
      answerSelected: false,
      showComment: false,
      commentPlaceholder: false,
      commentName: false,
      radioButtonCheckedPath: false,
      radioButtonUncheckedPath: false,
      thumbsUp: '',
      starHeight: 30,
      stars: [{
        value: 1,
        text: '',
        gradientFrom: '#FC8885',
        gradientTo: '#FB7C7F',
        selected: false,
      },
        {
          value: 2,
          text: '',
          gradientFrom: '#FB7A7E',
          gradientTo: '#F96A74',
          selected: false,
        },
        {
          value: 4,
          text: '',
          gradientFrom: '#F8636F',
          gradientTo: '#F75062',
          selected: false,
        },
        {
          value: 5,
          text: '',
          gradientFrom: '#F75165',
          gradientTo: '#F6415A',
          selected: false,
        }
      ]
    }
  },
  created() {
    // register the icon
    this.star = Star
  },
  mounted() {
    this.radioButtonCheckedPath = this.$store.getters.getRadioButtonCheckedPath;
    this.radioButtonUncheckedPath = this.$store.getters.getRadioButtonUnCheckedPath;
  },
  methods: {
    setRadio: function (uid) {
      this.showComment = false;
      this.commentPlaceholder = false;
      this.commentName = false;

      this.$emit("inputClick", uid);

      this.question.answers.forEach((item, index) => {
        if (item.uid === uid) {
          item.selected = true;
          if (item.is_allow_comment) {
            this.showComment = true;
            this.commentPlaceholder = item.comment_placeholder;
            this.commentName = 'comment_' + this.question.uid;
          }
          Vue.set(this.question.answers, index, item);
        } else {
          item.selected = false;
          Vue.set(this.question.answers, index, item);
        }

        this.$emit("checkDependency", uid);
      });
    },
    onRatingSelected(e) {
      this.setRadio(e);
    },
    resetStars() {
      this.question.answers.forEach(model => model.crowded = false)
    },
    selectStar(model, index) {
      console.log('select');
      this.resetStars()
      let i = 0;
      this.setRadio(model.uid);
      const f = () => {
        if (i <= index) {
          this.question.answers[i].crowded = true;
          i++;
          setTimeout(f, 100)
        }
        model.bounced = true;
      }
      model.bounced = false;
      setTimeout(f, 100)
    },
  },
  components: {
    Comment
  }
}
</script>

<style>

:root {
  --star-svg-height: '100px'
}

@keyframes bounce {
  0% {
    width: 32px;
    height: 56px;
  }
  25% {
    width: 34px;
    height: 58px;
  }
  50% {
    width: 36px;
    height: 59px;
  }
  100% {
    width: 38px;
    height: 60px;
  }
}

.bounce {
  animation-name: bounce;
  animation-duration: 0.2s;
}
</style>
<style lang="scss">
.rating-card__list {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  flex-basis: auto;

  &__item {
    flex-basis: 25%;
    flex-grow: 1;
    font-size: 12px;
    padding-left: 10px;

    .-checked & {
      font-weight: 200;
    }

    input {
      display: none;
    }

    input:checked + label {
      font-weight: 500;
    }

    svg {
      width: var(--star-svg-height);
      height: 54px;

      &:hover {
        cursor: pointer;
      }

      path {
        fill: #e6e7ea;
      }
    }

    &.-select {
      svg {
        path {
          fill: var(--radio-button-color)
        }
      }
    }
  }
}
</style>
